import { HebeCampaignPage, AdvertiserType, HebeCampaignType, HebeCampaignPosition, HebeCampaignProperty, HebeClientV2, CategoryId } from '@sbt-web/networking';
import { urnTransformer, slugify, isMobile, getMedalliaSurvey } from '@sbt-web/utils';
import React, { useState, useContext, useEffect } from 'react';
import { ShortModal, Button, Icon, IconName, IconSize, Close, Palette, FullModal } from '@sbt-web/ui';
import classnames$4 from 'classnames';
import Cookies from 'js-cookie';
import { buildAdDetailTarget } from '@sbt-web/tracking';
import { OptimizelySubitoContext } from '@sbt-web/houston-wrapper';
import ErrorBoundary from '@sbt-web/error-boundary';
import { useViewport } from '@sbt-web/hooks';

var ownClasses = {"dsa-section":"dsa-module_dsa-section__PmXcX","dsa-datum":"dsa-module_dsa-datum__Bh4x9"};

const DsaModal = ({ advertiser, agency, opened, onClose, }) => {
    return (React.createElement(ShortModal, { title: "Informazioni sulla pubblicit\u00E0", buttonConfiguration: {
            main: {
                action: onClose,
                text: 'Ok',
                design: 'solid',
            },
        }, open: opened, onClose: onClose },
        React.createElement("section", { className: ownClasses['dsa-section'] },
            React.createElement("p", { className: "body-text semibold" }, "Perch\u00E9 vedo questo messaggio pubblicitario?"),
            React.createElement("p", { className: "body-text" }, "Stai visualizzando questo messaggio pubblicitario in base all'annuncio che stai visualizzando.")),
        React.createElement("section", { className: ownClasses['dsa-section'] },
            React.createElement("dl", null,
                React.createElement("dt", { className: ownClasses['dsa-datum'] },
                    React.createElement("span", { className: "body-text semibold" }, "Nome dell'inserzionista")),
                React.createElement("dd", null, advertiser),
                React.createElement("dt", { className: ownClasses['dsa-datum'] },
                    React.createElement("span", { className: "body-text semibold" }, "Chi ha pagato per questo annuncio pubblicitario")),
                React.createElement("dd", null, agency)))));
};

const packFeatures = {
    '/car/brand': { idx: 0, ph: '/car' },
    '/car/model': { idx: 1, ph: '/car' },
    '/car/version': { idx: 2, ph: '/car' },
    '/bike/brand': { idx: 0, ph: '/bike' },
    '/bike/model': { idx: 1, ph: '/bike' },
    '/bike/version': { idx: 2, ph: '/bike' },
};
function replacePlaceholders$1(url, adItem) {
    const regex = /\{([a-zA-Z_/.]*)\}/g;
    let placeholder;
    let replaceUrl = url;
    try {
        while ((placeholder = regex.exec(url))) {
            const value = selectValue(placeholder[1], adItem);
            if (value) {
                replaceUrl = replaceUrl.replace(`{${placeholder[1]}}`, value);
            }
            else {
                replaceUrl = replaceUrl.replace(`{${placeholder[1]}}`, '');
            }
        }
    }
    catch (e) {
        replaceUrl = url;
        console.error(`Ancillary Services Placeholders: An error occurred while replacing placeholders`, e);
    }
    return replaceUrl;
}
function selectValue(placeholder, item) {
    // replace default ad info
    switch (placeholder) {
        case 'ad_id':
            return urnTransformer(item.urn)?.contentId;
        case 'town':
            return item.geo.town?.id;
        case 'urls_default':
            return item.urls?.default;
        case 'subito_image': {
            if (item.images[0]?.cdnBaseUrl) {
                return `${item.images[0].cdnBaseUrl}?rule=gallery-desktop-1x-auto`;
            }
            else {
                return '';
            }
        }
        case 'image_big': {
            if (item.images[0]?.cdnBaseUrl) {
                return `${item.images[0].cdnBaseUrl}?rule=images-auto`;
            }
            else {
                return '';
            }
        }
    }
    // normalize features placeholders
    let index = 0;
    let getLabel = false;
    if (placeholder.endsWith('.label')) {
        getLabel = true;
        placeholder = placeholder.replace('.label', '');
    }
    if (placeholder in packFeatures) {
        index = packFeatures[placeholder].idx;
        placeholder = packFeatures[placeholder].ph;
    }
    // replace custom placeholders
    if (placeholder.startsWith('garanty_')) {
        return manageGarantyPlaceholders(placeholder, item);
    }
    if (placeholder.startsWith('lendo_')) {
        return manageLendoPlaceholders(placeholder, item);
    }
    if (placeholder.startsWith('carfax_')) {
        return manageCarfaxPlaceholders(placeholder, item);
    }
    // replace features placeholders
    return manageFeaturesPlaceholders(placeholder, index, getLabel, item);
}
function manageFeaturesPlaceholders(placeholder, index, getLabel, item) {
    if (placeholder in item.features) {
        if (getLabel) {
            return (item.features[placeholder]?.values[index]?.value || '');
        }
        return item.features[placeholder]?.values[index]?.key || '';
    }
}
function manageLendoPlaceholders(placeholder, item) {
    switch (placeholder) {
        case 'lendo_vehicle_status':
            return formatVehicleStatusLendo(item.features['/vehicle_status']?.values[0]?.value || '', item.category.id);
        case 'lendo_advertiser':
            return item?.advertiser?.type === AdvertiserType.Private
                ? 'Privato'
                : 'Azienda';
        default:
            return '';
    }
}
function manageGarantyPlaceholders(placeholder, item) {
    switch (placeholder) {
        case 'garanty_infocar':
            return formatInfocarGaranty(slugify(item.features['/car']?.values[2]?.key || ''), slugify(item.features['/register_date']?.values[0]?.value || ''));
        case 'garanty_register_date':
            return formatDateGaranty(slugify(item.features['/register_date']?.values[0]?.value || ''));
        case 'garanty_gearbox':
            return formatGearboxGaranty(item.features['/gearbox']?.values[0]?.key || '');
        case 'garanty_fuel':
            return formatFuelGaranty(slugify(item.features['/fuel']?.values[0]?.key || ''));
    }
}
function manageCarfaxPlaceholders(placeholder, item) {
    switch (placeholder) {
        case 'carfax_ct_st':
            return item?.advertiser?.type === AdvertiserType.Private
                ? 'private'
                : 'dealer';
    }
}
const garantyGearboxMapping = {
    '1': 'M',
    '2': 'A',
    '3': 'S',
};
const garantyFuelMapping = {
    '1': 'B',
    '2': 'D',
    '3': 'G',
    '4': 'E',
    '6': 'I',
    '7': 'M',
};
const lendoVehicleStatusMapping = {
    Usato: 'used',
    Nuovo: 'new',
};
const formatDateGaranty = (date) => {
    const dateElem = date.split('-');
    if (dateElem.length > 0) {
        date = `${dateElem[1]}-${dateElem[0]}-01`;
    }
    return date;
};
const formatFuelGaranty = (fuel) => {
    return garantyFuelMapping[fuel] || '';
};
const formatVehicleStatusLendo = (vehicle_status, category) => {
    let category_label = 'car';
    if (category == '3') {
        category_label = 'motorcycle';
    }
    return `${lendoVehicleStatusMapping[vehicle_status]}_${category_label}`;
};
const formatGearboxGaranty = (gearbox) => {
    return garantyGearboxMapping[gearbox] || '';
};
const formatInfocarGaranty = (infocar, date) => {
    const dateElem = date.split('-');
    if (dateElem.length) {
        infocar = `${infocar}${dateElem[1]}${dateElem[0]}`;
    }
    return infocar;
};
const buildObjId = (aSEvent, pageValue) => {
    const getID = (adItem, searchId) => {
        if (adItem) {
            const { object: ClassifiedAd } = buildAdDetailTarget(adItem);
            delete ClassifiedAd.publisher;
            return urnTransformer(adItem.urn)?.adId;
        }
        else if (searchId) {
            return searchId;
        }
        return 'unknow';
    };
    return `sdrn:subito:${pageValue}:${getID(aSEvent.adItem, aSEvent.searchId)}:element:ancillaryService-${aSEvent.asType}-${aSEvent.pulseId}${aSEvent.isModal ? `-modal` : ''}`;
};
function getPulseASEvent(aSEvent) {
    const elementType = aSEvent.isModal ? 'modal' : 'banner';
    const pageValue = aSEvent.adItem ? 'classified' : 'listing';
    const label = aSEvent.label ? aSEvent.label : '';
    return {
        type: aSEvent.eventType,
        object: {
            '@id': buildObjId(aSEvent, pageValue),
            type: 'UIElement',
            elementType,
            pageType: pageValue,
            pageName: pageValue,
            label,
        },
    };
}
function trackAncillaryEvent(page, pulse_id, eventType, isModal, pulseInstance, item, searchId, asName) {
    if (!asName) {
        asName = page === HebeCampaignPage.ADDETAIL ? 'bodyblock' : 'cardblock';
    }
    const aSSchema = getPulseASEvent({
        asType: asName,
        adItem: item,
        searchId,
        isModal,
        pulseId: pulse_id,
        eventType,
    });
    pulseInstance?.queueEvent(aSSchema);
}

var classes$2 = {"root":"Banner-module_root__XHRwt","wrapper":"Banner-module_wrapper__cqGTQ","background-default":"Banner-module_background-default__HXJ3O","background":"Banner-module_background__JZICU","padding":"Banner-module_padding__IJ-fB","border":"Banner-module_border__LUwlb","article":"Banner-module_article__CP17H","info-icon":"Banner-module_info-icon__-YNMb","container":"Banner-module_container__icMdA","container-reverse":"Banner-module_container-reverse__d4ZSi","title_wrapper":"Banner-module_title_wrapper__u7Q5I","description":"Banner-module_description__QEhLj","size-small":"Banner-module_size-small__b2gjM","weight-semibold":"Banner-module_weight-semibold__xm6Og","weight-book":"Banner-module_weight-book__ejutt","img":"Banner-module_img__dGcNu","img-margin-right":"Banner-module_img-margin-right__1L8ZZ","img-margin-left":"Banner-module_img-margin-left__BQDrr","form":"Banner-module_form__lJNZC","closeIcon":"Banner-module_closeIcon__Iq3TG","button-wrapper":"Banner-module_button-wrapper__z1-4P","button":"Banner-module_button__fOmTY","button-outlined":"Banner-module_button-outlined__MZoQ6"};

function Banner(props) {
    const { flex, padding = true, border, reverse, background, data, type, bannerButtonDesign, closable, onSubmit, item, pulse_id = '', pulseInstance, page, searchId, advertiser, agency, } = props;
    const [closed, setClosed] = useState(false);
    const [dsaOpened, setDsaOpened] = useState(false);
    /**
     * Define background using service type
     */
    function getBackground() {
        return type === HebeCampaignType.CARD_BLOCK && isMobile()
            ? true
            : background;
    }
    function onCloseDsa() {
        setDsaOpened(false);
    }
    function onOpenDsa() {
        setDsaOpened(true);
    }
    function closeAction() {
        const newDate = new Date(new Date().setMonth(new Date().getMonth() + 2));
        Cookies.set(`${pulse_id}-closed`, 'true', { expires: newDate });
        setClosed(true);
        let asType;
        switch (type) {
            case HebeCampaignType.CARD_BLOCK:
                asType = 'cardblock';
                break;
            case HebeCampaignType.LINK:
                asType = 'linkservizi';
                break;
            case HebeCampaignType.TEXTLINK:
                asType = 'textlink';
                break;
            default:
                asType = 'widget';
        }
        trackAncillaryEvent(page, pulse_id, 'Close', false, pulseInstance, item, searchId, asType);
    }
    return (React.createElement("div", { className: classnames$4(props.classes) },
        !closed && (React.createElement("div", { className: classnames$4({
                [classes$2['root']]: type === HebeCampaignType.CARD_BLOCK,
            }) },
            React.createElement("article", { className: classnames$4(classes$2['article'], {
                    [classes$2['wrapper']]: !flex,
                    [classes$2['padding']]: padding,
                    [classes$2['background']]: getBackground(),
                    [classes$2['background-default']]: !getBackground(),
                    [classes$2['border']]: border,
                }) },
                React.createElement("div", { className: classnames$4({
                        [classes$2['container-reverse']]: reverse,
                        [classes$2['container']]: !reverse,
                    }) },
                    React.createElement("div", { className: classes$2['title_wrapper'] },
                        React.createElement("h3", { className: "headline-6" }, data.title),
                        React.createElement("p", { className: classes$2['description'] }, data.description)),
                    (!isMobile() || !closable) && data.image_url && (React.createElement("img", { alt: 'Vai al servizio', className: classnames$4(classes$2['img'], {
                            [classes$2['img-margin-right']]: !reverse && !isMobile(),
                            [classes$2['img-margin-left']]: reverse,
                        }), src: data.image_url, width: "64", height: "64" })),
                    advertiser && (React.createElement(Button, { design: "text", size: "small", icon: React.createElement(Icon, { name: IconName.Info, iconSize: IconSize.MD }), classes: [classes$2['info-icon']], onClick: onOpenDsa }))),
                React.createElement("div", { className: classnames$4({
                        [classes$2['button-wrapper']]: isMobile(),
                    }) },
                    React.createElement("form", { className: classes$2['form'], onSubmit: onSubmit },
                        React.createElement(Button, { classes: [classnames$4(classes$2['button'])], type: "submit", design: bannerButtonDesign }, data?.action))),
                closable && (React.createElement(Button, { design: "text", classes: [classnames$4(classes$2['closeIcon'])], onClick: closeAction },
                    React.createElement(Close, { width: IconSize.MD, height: IconSize.MD, fillColor: Palette.NeutralGrey1 })))))),
        advertiser && (React.createElement(DsaModal, { advertiser: advertiser, agency: agency, opened: dsaOpened, onClose: onCloseDsa }))));
}

var classnames$3 = {"dialog_wrapper":"BannerDialog-module_dialog_wrapper__1gNXH","dialog_title":"BannerDialog-module_dialog_title__B-2dc","weight-book":"BannerDialog-module_weight-book__luMgg","dialog_subtitle":"BannerDialog-module_dialog_subtitle__J49su"};

function BannerDialog(props) {
    const { opened, title, subtitle, logo, children } = props;
    const { onClose } = props;
    return (React.createElement(FullModal, { open: opened, onClose: onClose, size: 'small' },
        React.createElement("div", { className: classnames$3[`dialog_wrapper`] },
            logo,
            React.createElement("h3", { className: classnames$3[`dialog_title`] }, title),
            subtitle && (React.createElement("h6", { className: classnames$3[`dialog_subtitle`] }, subtitle)),
            children)));
}

var classnames$2 = {"logo-container":"Modal-module_logo-container__XPvR1","logo":"Modal-module_logo__ehbM1","step_container":"Modal-module_step_container__LYyAZ","step_button":"Modal-module_step_button__3hXl1","step_description":"Modal-module_step_description__zfvbn","footer_description":"Modal-module_footer_description__rVW-j","confirm_button":"Modal-module_confirm_button__rgbvY","size-small":"Modal-module_size-small__HW9L6","weight-semibold":"Modal-module_weight-semibold__Z3eZh","weight-book":"Modal-module_weight-book__MSNoj","price_wrapper":"Modal-module_price_wrapper__urs9d","price":"Modal-module_price__TXfde"};

function Modal(props) {
    const { opened } = props;
    const { onSubmit, onClose, data } = props;
    const { title, image_url, action, steps, subtitle, notes } = data;
    return (React.createElement(BannerDialog, { opened: opened, logo: image_url && (React.createElement("div", { className: classnames$2[`logo-container`] },
            React.createElement("img", { alt: 'logo', className: classnames$2[`logo`], src: image_url }))), title: title, subtitle: subtitle, onClose: onClose, onSubmit: onSubmit },
        steps.map((item, index) => (React.createElement("div", { className: classnames$2[`step_container`], key: `modal-step-${index}` },
            React.createElement("p", { className: classnames$2[`step_button`] }, index + 1),
            React.createElement("p", { className: classnames$2[`step_description`] }, item.text)))),
        React.createElement("div", { className: classnames$2[`footer_description`] }, notes),
        React.createElement("form", { onSubmit: onSubmit },
            React.createElement(Button, { classes: [classnames$2['confirm_button']], type: "submit", design: "solid" }, action))));
}

var classes$1 = {"form-container":"BannerFakeDoorDialog-module_form-container__KrY9I","confirm_button":"BannerFakeDoorDialog-module_confirm_button__DI0mP","size-small":"BannerFakeDoorDialog-module_size-small__cGDRz","weight-semibold":"BannerFakeDoorDialog-module_weight-semibold__BdSks","weight-book":"BannerFakeDoorDialog-module_weight-book__DQ3ng","button-auto":"BannerFakeDoorDialog-module_button-auto__310fE"};

function ModalFakeDoor(props) {
    const { opened, title, action, theme, subtitle } = props;
    const { onSubmit, onClose } = props;
    return (React.createElement(BannerDialog, { opened: opened, title: title, subtitle: subtitle, onClose: onClose, onSubmit: onSubmit },
        "Questo servizio non \u00E8 ancora disponibile, ti avviseremo quando potrai utilizzarlo",
        React.createElement("form", { className: classes$1['form-container'], onSubmit: onClose },
            React.createElement(Button, { classes: [
                    classnames$4(classes$1['confirm_button'], theme && classes$1[`button-${theme}`]),
                ], type: "submit", design: "solid" }, action))));
}

const generalMockData$1 = {
    id: 0,
    name: 'campaign',
    pulse_id: '',
    survey_id: '',
    survey_id_ios: '',
    survey_id_android: '',
    status: 'activated',
    started_at: '2020-06-01T02:00:00Z',
    ended_at: '2030-06-01T02:00:00Z',
    advertiser: 'BMW',
    agency: 'BMW',
    touchpoint: {
        page: HebeCampaignPage.LISTING,
        position: HebeCampaignPosition.NINTH_POSITION,
    },
    filters: [],
    metadata: {
        categories: ['1'],
        advertiser_ids: [''],
        advertiser_types: ['impresa-piu', 'privato', 'azienda-non-pro'],
        ad_types: ['s'],
        keywords: [],
        geo: {},
        properties: [HebeCampaignProperty.WEB, HebeCampaignProperty.MSITE],
    },
    layout: {
        type: HebeCampaignType.CARD_BLOCK,
        item: {
            title: '',
            description: '',
            url: '',
            image_url: '',
            action: '',
        },
        modal: {
            title: '',
            image_url: '',
            action: '',
            steps: [],
        },
    },
};

const initialCardBlockData = {
    id: 0,
    name: '',
    ended_at: '',
    started_at: '',
    advertiser: '',
    agency: '',
    status: '',
    touchpoint: {
        page: HebeCampaignPage.LISTING,
        position: HebeCampaignPosition.NINTH_POSITION,
    },
    filters: [],
    metadata: {
        properties: [],
        advertiser_types: [''],
        advertiser_ids: [''],
        ad_types: [''],
        keywords: [],
    },
    pulse_id: '',
    survey_id: '',
    survey_id_ios: '',
    survey_id_android: '',
    layout: {
        type: HebeCampaignType.CARD_BLOCK,
        item: {
            title: '',
            description: '',
            image_url: '',
            url: '',
            action: '',
        },
        modal: {
            title: '',
            image_url: '',
            action: '',
            steps: [],
        },
    },
};
const MockDataCardBlock = (assetsBase) => ({
    ...generalMockData$1,
    name: 'campaign_card_block',
    pulse_id: 'my-pulseId',
    survey_id: '',
    touchpoint: {
        page: HebeCampaignPage.LISTING,
        position: HebeCampaignPosition.NINTH_POSITION,
    },
    metadata: {
        ...generalMockData$1.metadata,
    },
    layout: {
        modal: {
            title: '',
            image_url: '',
            action: '',
            steps: [],
        },
        type: HebeCampaignType.CARD_BLOCK,
        item: {
            title: 'Subito: compra e vendi vicino a te - Annunci gratuiti',
            description: 'Vendi e compra nuovo e usato online in modo semplice, rapido e sicuro. Oltre 6 milioni di annunci di auto, case, lavoro, elettronica, arredamento, animali e tanto altro',
            url: 'https://www.subito.it/',
            image_url: `${assetsBase}/static/logos/grey-short.svg`,
            action: 'Scopri di più',
        },
    },
});

const MockDataCarWash = (assetsBase) => {
    return {
        ...generalMockData$1,
        name: 'campaign_vehicle_history',
        pulse_id: 'car-wash',
        touchpoint: {
            page: HebeCampaignPage.MANAGE_ADS,
            position: HebeCampaignPosition.TOP_ADS,
        },
        metadata: {
            ...generalMockData$1.metadata,
        },
        layout: {
            type: HebeCampaignType.CARD_BLOCK,
            item: {
                title: 'Lavaggio auto in concessionaria',
                description: 'Garantisci la massima sicurezza ai tuoi clienti grazie al servizio di pulizia e igienizzazione dei veicoli direttamente presso la tua concessionaria.',
                url: '{{FAKE_DOOR}}',
                image_url: `${assetsBase}/static/ancillary-services/vehicle-history/carfax-logo.png`,
                action: 'Scopri di più',
            },
            modal: {
                title: 'Lavaggio auto in concessionaria',
                image_url: ``,
                action: 'Acquista',
                steps: [],
            },
        },
    };
};

const generalMacingoMockData = (assetsBase) => ({
    id: 0,
    name: 'campaign_macingo',
    pulse_id: 'pulse-campaign_macingo-id',
    survey_id: '',
    survey_id_ios: '',
    survey_id_android: '',
    status: 'activated',
    started_at: '2020-06-01T02:00:00Z',
    ended_at: '2030-06-01T02:00:00Z',
    filters: [],
    touchpoint: {
        page: HebeCampaignPage.ADDETAIL,
        position: HebeCampaignPosition.BELOW_DESCRIPTION,
    },
    metadata: {
        ...generalMockData$1.metadata,
    },
    layout: {
        type: HebeCampaignType.CARD_BLOCK,
        item: {
            title: 'Il tuo veicolo a domicilio',
            description: 'Scegli di far recapitare il veicolo direttamente a casa tua utilizzando Macingo!',
            url: 'https://www.macingo.com/',
            image_url: `${assetsBase}/static/ancillary-services/macingo/logo-macingo-marchio.png`,
            action: 'Scopri di più',
        },
        modal: {
            title: 'Confronta i prezzi per la consegna a domicilio',
            image_url: `${assetsBase}/static/ancillary-services/macingo/logo-macingo-intero.png`,
            action: 'Continua',
            steps: [
                {
                    index: 1,
                    text: 'Inserisci luogo di ritiro e di consegna ed eventuali informazioni aggiuntive',
                },
                {
                    index: 2,
                    text: 'Effettua il login o registrati su Macingo',
                },
                {
                    index: 3,
                    text: 'Ottieni una lista di preventivi e scegli la soluzione migliore',
                },
            ],
        },
    },
});
const MockDataMacingoAuto = (assetsBase) => {
    const generalData = generalMacingoMockData(assetsBase);
    return {
        ...generalData,
        touchpoint: {
            page: HebeCampaignPage.ADDETAIL,
            position: HebeCampaignPosition.BELOW_DESCRIPTION,
        },
        layout: {
            ...generalData.layout,
            item: {
                ...generalData.layout.item,
                title: 'La tua auto a domicilio',
                description: 'Scegli di far recapitare il veicolo direttamente a casa tua utilizzando Macingo!',
                url: `https://www.macingo.com/creazione/trasporto-auto?utm_source=subito-it-auto&utm_medium=referral&utm_campaign=Subito`,
            },
        },
    };
};
const MockDataMacingoMoto = (assetsBase) => {
    const generalData = generalMacingoMockData(assetsBase);
    return {
        ...generalData,
        touchpoint: {
            page: HebeCampaignPage.ADDETAIL,
            position: HebeCampaignPosition.BELOW_DESCRIPTION,
        },
        layout: {
            ...generalData.layout,
            item: {
                ...generalData.layout.item,
                title: 'La tua moto a domicilio',
                description: 'Scegli di far recapitare il veicolo direttamente a casa tua utilizzando Macingo!',
                url: `https://www.macingo.com/creazione/trasporto-moto?utm_source=subito-it-moto&utm_medium=referral&utm_campaign=Subito`,
            },
        },
    };
};
const MockDataMacingoNautica = (assetsBase) => {
    const generalData = generalMacingoMockData(assetsBase);
    return {
        ...generalData,
        touchpoint: {
            page: HebeCampaignPage.ADDETAIL,
            position: HebeCampaignPosition.BELOW_DESCRIPTION,
        },
        layout: {
            ...generalData.layout,
            item: {
                ...generalData.layout.item,
                title: 'La tua imbarcazione a domicilio',
                description: 'Scegli di far recapitare il veicolo direttamente a casa tua utilizzando Macingo!',
                url: `https://www.macingo.com/creazione/trasporto-barche?utm_source=subito-it-barche&utm_medium=referral&utm_campaign=Subito`,
            },
        },
    };
};
const MockDataMacingoAnimali = (assetsBase) => {
    const generalData = generalMacingoMockData(assetsBase);
    return {
        ...generalData,
        touchpoint: {
            page: HebeCampaignPage.LISTING,
            position: HebeCampaignPosition.NINTH_POSITION,
        },
        layout: {
            ...generalData.layout,
            item: {
                ...generalData.layout.item,
                title: 'Consegna a domicilio',
                description: 'Valuta la soluzione migliore per il trasporto a domicilio con Macingo',
                url: 'https://www.macingo.com/trasporto-animali-domestici?utm_source=subito-it-animali&utm_medium=referral&utm_campaign=Subito',
                action: 'Scopri di più',
            },
            modal: {
                title: 'Confronta i prezzi per la consegna a domicilio',
                action: 'Continua',
                image_url: `${assetsBase}/static/reclame/logos/logo_macingo_intero.png`,
                steps: [
                    {
                        index: 1,
                        text: 'Inserisci luogo di ritiro e di consegna ed eventuali informazioni aggiuntive',
                    },
                    {
                        index: 2,
                        text: 'Effettua il login o registrati su Macingo',
                    },
                    {
                        index: 3,
                        text: 'Ottieni una lista di preventivi e scegli la soluzione migliore',
                    },
                ],
            },
        },
    };
};

const MockDataTestDrive = (assetsBase) => {
    return {
        ...generalMockData$1,
        name: 'campaign_test_drive_land_rover',
        pulse_id: 'request-testdrive-landrover',
        survey_id: '18888',
        touchpoint: {
            page: HebeCampaignPage.LISTING,
            position: HebeCampaignPosition.NINTH_POSITION,
        },
        metadata: {
            ...generalMockData$1.metadata,
        },
        layout: {
            type: HebeCampaignType.CARD_BLOCK,
            item: {
                title: 'Test drive Land Rover Discovery',
                description: "Prova l'esperienza Land Rover presso il centro autorizzato più vicino a te!",
                url: 'https://www.google.com/',
                image_url: `${assetsBase}/static/ancillary-services/test-drive/land-rover/land-rover-logo.png`,
                action: 'Richiedi test drive',
            },
            modal: {
                title: 'Richiedi il test drive in pochi e semplici passi',
                image_url: `${assetsBase}/static/ancillary-services/test-drive/land-rover/Land_rover_TD.png`,
                action: 'Continua',
                steps: [
                    {
                        index: 1,
                        text: 'Inserisci i tuoi dati e invia la richiesta per il test drive',
                    },
                    {
                        index: 2,
                        text: 'Aspetta di essere ricontattato per fissare un appuntamento nella concessionaria più vicina',
                    },
                    {
                        index: 3,
                        text: 'Vivi la tua esperienza Land Rover direttamente su strada',
                    },
                ],
            },
        },
    };
};

/**
 * CardBlock is a configurable ancillary service banner from the Hebe console: http://hebe-console.subito-dev.schip.io/
 *
 * Different services are renderable with configuration in different placement of subito.it
 */
function CardBlock(props) {
    const { config, mockData, remoteData, item, bannerButtonDesign, classes } = props;
    const [loader, setLoader] = useState(true);
    const [data, setData] = useState(initialCardBlockData);
    const [dialogs, setDialogs] = useState({
        modal: false,
        fakeDoor: false,
    });
    const { optimizely } = useContext(OptimizelySubitoContext);
    const trackHoustonEvent = () => optimizely?.track?.('Click_Ancillary_Services');
    const localConf = mockData;
    useEffect(() => {
        if (remoteData) {
            const { baseUrl, params, body } = remoteData;
            const client = new HebeClientV2(baseUrl, 'web', 10000);
            client
                .getLookupCampaigns(params, body)
                .then((res) => {
                const data = res.payload;
                if (data?.campaigns?.length > 0) {
                    const campaign = data.campaigns[0];
                    setData(campaign);
                    setLoader(false);
                    trackAncillaryEvent(campaign.touchpoint.page, campaign.pulse_id, 'View', false, props.pulseInstance, props.item, props.searchId);
                }
            })
                .catch((err) => console.error(`CardBlock service error: ${err.message}`));
        }
        else {
            if (localConf) {
                setData(localConf);
                trackAncillaryEvent(localConf.touchpoint.page, localConf.pulse_id, 'View', false, props.pulseInstance, props.item, props.searchId);
                setLoader(false);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
     * onClick on CTA button [Banner]
     * @param e
     */
    function onBannerCtaSubmit(e) {
        e.preventDefault();
        const hasModal = data.layout.modal;
        if (hasModal) {
            setDialogs((p) => ({ ...p, modal: true }));
        }
        else {
            window.open(item
                ? replacePlaceholders$1(data.layout.item.url, item)
                : data.layout.item.url, '_target');
            getMedalliaSurvey(data.survey_id);
        }
        trackAncillaryEvent(data.touchpoint.page, data.pulse_id, 'Click', false, props.pulseInstance, props.item, props.searchId);
        trackHoustonEvent();
        if (hasModal) {
            trackAncillaryEvent(data.touchpoint.page, data.pulse_id, 'View', true, props.pulseInstance, props.item, props.searchId);
        }
    }
    /**
     * onClick on CTA button [Modal]
     * @param e
     */
    function onModalSubmit(e) {
        e.preventDefault();
        window.open(item
            ? replacePlaceholders$1(data.layout.item.url, item)
            : data.layout.item.url, '_target');
        getMedalliaSurvey(data.survey_id);
        setDialogs((p) => ({ ...p, modal: false }));
        trackAncillaryEvent(data.touchpoint.page, data.pulse_id, 'Click', true, props.pulseInstance, props.item, props.searchId);
        trackHoustonEvent();
    }
    /**
     * onClose [Modal]
     * @param e
     */
    function onModalClose(e) {
        e?.preventDefault();
        trackAncillaryEvent(data.touchpoint.page, data.pulse_id, 'Close', true, props.pulseInstance, props.item, props.searchId);
        setDialogs((p) => ({ ...p, modal: false, fakeDoor: false }));
    }
    return (React.createElement(React.Fragment, null,
        !Cookies.get(`${data.layout.type}-closed`) &&
            data?.layout?.item &&
            !loader && (React.createElement(Banner, { ...props, data: data?.layout?.item, type: data.layout.type, onSubmit: onBannerCtaSubmit, bannerButtonDesign: bannerButtonDesign, classes: classes, page: data.touchpoint.page, advertiser: data.advertiser, agency: data.agency })),
        data?.layout.modal && (React.createElement(React.Fragment, null,
            React.createElement(Modal, { opened: dialogs.modal, onSubmit: onModalSubmit, onClose: onModalClose, data: data.layout.modal, config: config }),
            React.createElement(ModalFakeDoor, { opened: dialogs.fakeDoor, onSubmit: onModalClose, onClose: onModalClose, title: data.layout.modal.title, action: "Torna indietro" })))));
}

var AdBannerService;
(function (AdBannerService) {
    AdBannerService["Macingo"] = "macingo";
    AdBannerService["VehicleHistory"] = "vehicle-history";
    AdBannerService["TestDrive"] = "test-drive";
    AdBannerService["CardBlock"] = "card-block";
    AdBannerService["CarWash"] = "car-wash";
    AdBannerService["Findomestic"] = "findomestic";
})(AdBannerService || (AdBannerService = {}));

const MockDataVehicleHistory = (assetsBase) => {
    return {
        ...generalMockData$1,
        name: 'campaign_vehicle_history',
        pulse_id: 'car-history',
        survey_id: '22133',
        touchpoint: {
            page: HebeCampaignPage.ADDETAIL,
            position: HebeCampaignPosition.BELOW_HISTORY,
        },
        metadata: {
            ...generalMockData$1.metadata,
        },
        layout: {
            type: HebeCampaignType.CARD_BLOCK,
            item: {
                title: 'Report storico del veicolo',
                description: "Con CARFAX puoi richiedere un report dettagliato dell'auto con informazioni relative agli incidenti gravi, alle revisioni, alle letture del contachilometri e molto altro.",
                url: 'https://www.carfax.eu/it/partner/subito?adurl={urls_default}&pic={image_big}&make={brand}&model={model}#utm_source=subito.it&utm_medium=website&utm_content=website_link&utm_campaign=classifieds_integration&ct_pm=model_1&ct_st={carfax_ct_st}&ct_ts=consumer',
                image_url: `${assetsBase}/static/ancillary-services/vehicle-history/carfax-logo.png?v=3`,
                action: 'Scopri di più',
            },
        },
    };
};

const generalMockData = {
    id: 0,
    name: 'campaign',
    pulse_id: '',
    survey_id: '',
    survey_id_ios: '',
    survey_id_android: '',
    status: 'activated',
    started_at: '2020-06-01T02:00:00Z',
    ended_at: '2030-06-01T02:00:00Z',
    filters: [],
    touchpoint: {
        page: HebeCampaignPage.LISTING,
        position: HebeCampaignPosition.NINTH_POSITION,
    },
    metadata: {
        properties: [HebeCampaignProperty.WEB, HebeCampaignProperty.MSITE],
        categories: ['1'],
        advertiser_types: [''],
        advertiser_ids: [''],
        ad_types: [''],
        keywords: [],
        geo: {},
    },
    layout: {
        type: HebeCampaignType.CARD_BLOCK,
        item: {
            title: '',
            description: '',
            url: '',
            image_url: '',
            action: '',
        },
        modal: {
            title: '',
            image_url: '',
            action: '',
            steps: [],
        },
    },
};

const MockDataWesual = (assetsBase) => ({
    ...generalMockData,
    name: 'campaign_wesual',
    pulse_id: 'wesual',
    survey_id: '00000',
    touchpoint: {
        page: HebeCampaignPage.MANAGE_ADS,
        position: HebeCampaignPosition.TOP_ADS,
    },
    metadata: {
        ...generalMockData.metadata,
    },
    layout: {
        type: HebeCampaignType.CARD_BLOCK,
        item: {
            title: 'Migliora le foto del tuo annuncio',
            description: 'Ottieni immagini professionali per il tuo immobile, consegna veloce e puntuale in meno di 48 ore.',
            url: 'https://www.wesual.co/wesual-on-demand-foto-video-a?utm_source=subito&utm_medium=cpc&utm_campaign=immobili',
            image_url: `${assetsBase}/static/ancillary-services/wesual/logo-wesual-marchio.png`,
            action: 'Scopri di più',
            closable: true,
        },
        modal: {
            title: 'Richiedi un book fotografico professionale',
            subtitle: 'Moltiplica i contatti e le visualizzazioni del tuo annuncio tramite foto professionali',
            image_url: `${assetsBase}/static/ancillary-services/wesual/logo-wesual-intero.png`,
            action: 'Prenota un servizio fotografico',
            steps: [
                {
                    index: 1,
                    text: 'Ordina online il tuo servizio fotografico. In pochi e semplici passaggi su Wesual.',
                },
                {
                    index: 2,
                    text: 'Un fotografo professionista raggiungerà il luogo indicato, all’ora prestabilita, per realizzare lo shooting.',
                },
                {
                    index: 3,
                    text: 'In meno di 48 ore dalla visita del fotografo potrai scaricare tutte le tue foto, post-prodotte e ottimizzate per il tuo annuncio.',
                },
            ],
        },
    },
});

const MockDataFindomestic = (assetsBase, item) => ({
    ...generalMockData,
    name: 'campaign_findomestic',
    pulse_id: 'findomestic',
    survey_id: '22028',
    metadata: {
        ...generalMockData.metadata,
    },
    layout: {
        type: HebeCampaignType.CARD_BLOCK,
        item: {
            title: 'Richiedi il tuo prestito online',
            description: buildDesc(item),
            url: buildUrl(item),
            image_url: `${assetsBase}/static/ancillary-services/findomestic/findomestic.svg`,
            action: 'Scopri di più',
        },
        modal: {
            title: 'Richiedi il tuo prestito grazie alla procedura 100% online.',
            image_url: `${assetsBase}/static/ancillary-services/findomestic/findomestic.svg`,
            action: 'Continua',
            steps: [
                {
                    index: 1,
                    text: "Seleziona il tuo progetto, inserisci l'importo e calcola il prestito",
                },
                {
                    index: 2,
                    text: 'Puoi chiederlo subito cliccando su "Richiedi Finanziamento"',
                },
                {
                    index: 3,
                    text: "Carica tutti i documenti che ti verranno richiesti e riceverai l'esito in pochi giorni",
                },
            ],
        },
    },
});
function buildUrl(item) {
    switch (item.category.id) {
        case CategoryId.Biciclette:
            return 'https://ad.doubleclick.net/ddm/trackclk/N4199.157827SUBITO.ITS.R.L._GM/B25336261.315270292;dc_trk_aid=507494252;dc_trk_cid=158350006;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;ltd=';
        case CategoryId.Appartamenti:
            return 'https://ad.doubleclick.net/ddm/trackclk/N4199.157827SUBITO.ITS.R.L._GM/B25336261.315705496;dc_trk_aid=508242090;dc_trk_cid=158350006;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;ltd=';
        default:
            return '';
    }
}
function buildDesc(item) {
    switch (item.category.id) {
        case CategoryId.Biciclette:
            return 'Con Findomestic puoi richiedere un prestito per acquistare la tua bici direttamente online. Importo a partire da 1.000 € senza costi accessori.';
        case CategoryId.Appartamenti:
            return 'Con Findomestic puoi ottenere un prestito per i tuoi lavori di ristrutturazione direttamente online.';
        default:
            return 'Con Findomestic puoi richiedere un prestito per acquistare la tua bici direttamente online. Importo a partire da 1.000 € senza costi accessori.';
    }
}

const MockDataVolksvagen = (assetsBase) => ({
    ...generalMockData,
    name: 'campaign_volkswagen-services',
    pulse_id: 'volkswagen-services',
    survey_id: '22312',
    metadata: {
        ...generalMockData.metadata,
    },
    layout: {
        type: HebeCampaignType.CARD_BLOCK,
        item: {
            title: 'Volkswagen Service Extra Value',
            description: 'Subito per te un coupon da 50 € per la manutenzione della tua auto.',
            url: 'https://pubads.g.doubleclick.net/gampad/clk?id=5829349425&iu=/11825272/Ros_Textlink',
            image_url: `${assetsBase}/static/ancillary-services/volkswagen/volkswagen.svg`,
            action: 'Scarica il coupon',
        },
        modal: {
            title: 'Volkswagen Service Extra Value',
            image_url: `${assetsBase}/static/ancillary-services/volkswagen/volkswagen.svg`,
            action: 'Scarica il coupon',
            steps: [
                {
                    index: 1,
                    text: 'Inserisci i tuoi dati e la targa della tua auto',
                },
                {
                    index: 2,
                    text: 'Seleziona il Centro Volkswagen Service a te più comodo',
                },
                {
                    index: 3,
                    text: 'Scarica il coupon da 50 € da utilizzare per manutenzione e acquisto accessori',
                },
            ],
        },
    },
});

const MockDataCreditAgricole = (assetsBase) => ({
    ...generalMockData,
    name: 'campaign_credit-agricole',
    pulse_id: 'credit-agricole',
    survey_id: '20335',
    metadata: {
        ...generalMockData.metadata,
    },
    layout: {
        type: HebeCampaignType.CARD_BLOCK,
        item: {
            title: 'Richiedi il tuo mutuo online',
            description: 'Scegli il Mutuo Crédit Agricole e inizia a pagare dopo 1 anno. Calcola la tua rata online',
            url: 'http://pubads.g.doubleclick.net/gampad/clk?id=5830434463&iu=/11825272/Ros_Textlink',
            image_url: `${assetsBase}/static/ancillary-services/credit-agricole/logo-credit-agricole.svg`,
            action: 'Calcola rata',
            closable: false,
        },
    },
});

var classnames$1 = {"usefullink":"UsefulLinks-module_usefullink__aWZFw","info-icon":"UsefulLinks-module_info-icon__GPL8k","container":"UsefulLinks-module_container__8FAqg"};

function trackUsefullLinkView(usefullink, props) {
    const { pulseInstance, item, searchId } = props;
    trackAncillaryEvent(usefullink.touchpoint.page, usefullink.pulse_id, 'View', false, pulseInstance, item, searchId, 'linkservizi');
}
function trackUsefullLinkClick(event, data) {
    event.stopPropagation();
    const { usefullink, props } = data;
    const { pulseInstance, item, searchId } = props;
    trackAncillaryEvent(usefullink.touchpoint.page, usefullink.pulse_id, 'Click', false, pulseInstance, item, searchId, 'linkservizi');
    getMedalliaSurvey(usefullink.survey_id);
}
/**
 * UsefulLinks is a configurable ancillary service link from the Hebe console: http://hebe-console.subito-dev.schip.io/
 *
 * Different link are renderable with configuration in different placement of subito.it
 */
function UsefulLinksComponent(props) {
    const [data, setData] = useState([]);
    const { remoteData, item } = props;
    const [dsaOpenedId, setDsaOpenedId] = useState(null);
    const { optimizely } = useContext(OptimizelySubitoContext);
    const onCloseDsa = () => {
        setDsaOpenedId(null);
    };
    const onOpenDsa = (id) => {
        setDsaOpenedId(id);
    };
    useEffect(() => {
        const { baseUrl, body } = remoteData;
        const client = new HebeClientV2(baseUrl, 'web', 10000);
        client
            .getLookupCampaigns({}, body)
            .then((res) => {
            const data = res.payload;
            if (data?.campaigns?.length > 0) {
                setData(data.campaigns);
            }
        })
            .catch((err) => console.error(`Usefullinks service error: ${err.message}`));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        if (data.length > 0) {
            data.map((usefullink) => trackUsefullLinkView(usefullink, props));
        }
    }, [data, props]);
    return data.length > 0 ? (React.createElement("div", { id: 'usefullinks_wrapper', className: classnames$4(props.classes) }, data.map((usefullink) => (React.createElement("div", { key: `usefullink_${usefullink.name}`, className: classnames$1['container'] },
        React.createElement("a", { id: usefullink.name, href: replacePlaceholders$1(usefullink.layout.item.url, item), className: classnames$1['usefullink'], target: "_blank", rel: "nofollow noreferrer", onClick: (e) => {
                trackUsefullLinkClick(e, { usefullink, props });
                optimizely?.track?.('Click_Ancillary_Services');
            } }, usefullink.layout.item.action),
        usefullink.advertiser && (React.createElement(React.Fragment, null,
            React.createElement(Button, { design: "text", size: "small", icon: React.createElement(Icon, { name: IconName.Info, iconSize: IconSize.MD }), classes: [classnames$1['info-icon']], onClick: () => onOpenDsa(usefullink.id) }),
            React.createElement(DsaModal, { advertiser: usefullink.advertiser, agency: usefullink.agency, opened: dsaOpenedId === usefullink.id, onClose: onCloseDsa })))))))) : null;
}
function UsefulLinks(props) {
    return (React.createElement(ErrorBoundary, null,
        React.createElement(UsefulLinksComponent, { ...props })));
}

var classes = {"autopromo_img":"TextLink-module_autopromo_img__RKlA-","image":"TextLink-module_image__QIC0G","autopromo_listing":"TextLink-module_autopromo_listing__1dfhV","autopromo_txt":"TextLink-module_autopromo_txt__4ueTo","autopromo_adview":"TextLink-module_autopromo_adview__i1GxZ","info-icon":"TextLink-module_info-icon__YnoYo"};

function replacePlaceholders(url) {
    let replaceUrl = url;
    try {
        replaceUrl = replaceUrl.replace(`{math_random}`, String(Math.random()));
    }
    catch (e) {
        replaceUrl = url;
        console.error(`Ancillary Services Textlink Placeholders: An error occurred while replacing placeholders`, e);
    }
    return replaceUrl;
}

function trackTextLinkClick(event, data) {
    event.stopPropagation();
    const { textlink, props } = data;
    const { pulseInstance, item, searchId } = props;
    trackAncillaryEvent(textlink.touchpoint.page, textlink.pulse_id, 'Click', false, pulseInstance, item, searchId, 'textlink');
}
/**
 * TextLink is a configurable ancillary service from the Hebe console: http://hebe-console.subito-dev.schip.io/
 *
 * Different link are renderable with configuration in different placement of subito.it
 */
function TextLinkComponent(props) {
    const [data, setData] = useState([]);
    const { remoteData, maxNumberTextlinks } = props;
    const [dsaOpenedId, setDsaOpenedId] = useState(null);
    const { optimizely } = useContext(OptimizelySubitoContext);
    const onCloseDsa = () => {
        setDsaOpenedId(null);
    };
    const onOpenDsa = (id) => {
        setDsaOpenedId(id);
    };
    useEffect(() => {
        const { baseUrl, body } = remoteData;
        const client = new HebeClientV2(baseUrl, 'web', 10000);
        client
            .getLookupCampaigns({}, body)
            .then((res) => {
            const data = res.payload;
            if (data?.campaigns?.length > 0) {
                setData(data.campaigns);
            }
        })
            .catch((err) => console.error(`Ancillary Service TextLink service error: ${err.message}`));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        if (data.length > 0) {
            data.forEach((textlink, index) => {
                if (maxNumberTextlinks ? index < maxNumberTextlinks : true) {
                    trackAncillaryEvent(textlink.touchpoint.page, textlink.pulse_id, 'View', false, props.pulseInstance, props.item, props.searchId, 'textlink');
                }
            });
        }
    }, [data, maxNumberTextlinks, props]);
    return data.length > 0 ? (React.createElement("div", { id: 'textlinks_wrapper' }, data.map((textlink, index) => (!maxNumberTextlinks || index < maxNumberTextlinks) && (React.createElement("div", { key: `texlink_${textlink.name}`, className: classes[textlink.touchpoint.page === HebeCampaignPage.ADDETAIL
            ? 'autopromo_adview'
            : 'autopromo_listing'] },
        React.createElement("div", { className: classnames$4(classes['autopromo_img']) },
            React.createElement("a", { href: textlink.layout.item.url, rel: "noopener noreferrer", target: "_blank", className: classes['image'] },
                React.createElement("img", { src: textlink.layout.item.image_url, alt: textlink.name, width: "80", height: "60" }))),
        React.createElement("div", { className: classnames$4(classes['autopromo_txt']) },
            React.createElement("a", { onClick: (e) => {
                    trackTextLinkClick(e, { textlink, props });
                    optimizely?.track?.('Click_Ancillary_Services');
                }, href: textlink.layout.item.url, rel: "noopener noreferrer", target: "_blank" },
                textlink.layout.item.action,
                textlink.tracking_pixel_url && (React.createElement("img", { alt: "", width: "1", height: "1", src: replacePlaceholders(textlink.tracking_pixel_url) })))),
        textlink.advertiser && (React.createElement(React.Fragment, null,
            React.createElement(Button, { design: "text", size: "small", icon: React.createElement(Icon, { name: IconName.Info, iconSize: IconSize.MD }), classes: [classes['info-icon']], onClick: () => onOpenDsa(textlink.id) }),
            React.createElement(DsaModal, { advertiser: textlink.advertiser, agency: textlink.agency, opened: dsaOpenedId === textlink.id, onClose: onCloseDsa })))))))) : null;
}
function TextLink(props) {
    return (React.createElement(ErrorBoundary, null,
        React.createElement(TextLinkComponent, { ...props })));
}

function trackWidgetClick(event, data, label) {
    event.stopPropagation();
    const { pulse_id, props } = data;
    const { pulseInstance } = props;
    const aSSchema = getPulseASEvent({
        asType: 'widget',
        adItem: props.item,
        isModal: false,
        pulseId: pulse_id,
        eventType: 'Click',
        label,
    });
    pulseInstance?.queueEvent(aSSchema);
}
function trackWidgetView(pulse_id, props, label) {
    const { item, pulseInstance } = props;
    const aSSchema = getPulseASEvent({
        asType: 'widget',
        adItem: item,
        isModal: false,
        pulseId: pulse_id,
        eventType: 'View',
        label,
    });
    pulseInstance?.queueEvent(aSSchema);
}

var classnames = {"loan-price-link":"loanbox-module_loan-price-link__KELkX","loanButton":"loanbox-module_loanButton__KuwMy","insuranceButton":"loanbox-module_insuranceButton__CrcbN","marketButton":"loanbox-module_marketButton__tAabq","transportButton":"loanbox-module_transportButton__ficfZ","ad-info":"loanbox-module_ad-info__iohAo","ad_details":"loanbox-module_ad_details__KPD3H","box_container":"loanbox-module_box_container__HJZ47","block_container":"loanbox-module_block_container__TbtDu","header-container":"loanbox-module_header-container__JQuIq","ad_info":"loanbox-module_ad_info__-OoOC","box_logo":"loanbox-module_box_logo__-lAhn","box_logo_agos":"loanbox-module_box_logo_agos__9KqGM","box_logo_prestipay":"loanbox-module_box_logo_prestipay__Nb5HN","box_logo_credit_agricole":"loanbox-module_box_logo_credit_agricole__yL4R1","box_payoff":"loanbox-module_box_payoff__L-4d9","box_form_input":"loanbox-module_box_form_input__mJ5DY","agos_background":"loanbox-module_agos_background__9ass8","prestipay_background":"loanbox-module_prestipay_background__Rnh29","credit_agricole_background":"loanbox-module_credit_agricole_background__eLEvy","box_form_notes":"loanbox-module_box_form_notes__KrElE","smallprint":"loanbox-module_smallprint__8oZRP","info-icon":"loanbox-module_info-icon__sneAf","item-title":"loanbox-module_item-title__IPF3e","block_payoff":"loanbox-module_block_payoff__3sxGl","form_block":"loanbox-module_form_block__fXWB2","button":"loanbox-module_button__rpkt-","button-prestipay":"loanbox-module_button-prestipay__H8Xo3","button-credit-agricole":"loanbox-module_button-credit-agricole__P4-z5","ending-text":"loanbox-module_ending-text__FSH2L","usefull-link-container":"loanbox-module_usefull-link-container__jQjkg","flex-row":"loanbox-module_flex-row__Kp0Z1","usefull-external-links-container":"loanbox-module_usefull-external-links-container__kmI4W","insurance_container":"loanbox-module_insurance_container__BmM96","row-elem":"loanbox-module_row-elem__oNq7d","flex-container":"loanbox-module_flex-container__Eybul","icon-agos":"loanbox-module_icon-agos__-a15U","loan-container":"loanbox-module_loan-container__XFQM9","base-line":"loanbox-module_base-line__V7zTL"};

function isPriceInRange$1(price) {
    return price && price >= 500;
}
function getLoanPrice$1(price) {
    if (price >= 30000) {
        return 30000;
    }
    const prefixPrice = Math.floor(price / 1000) * 1000;
    const leftOver = Math.floor(price % 1000);
    if (leftOver === 0) {
        return price;
    }
    const suffixPrice = leftOver < 400 ? 500 : 1000;
    return prefixPrice + suffixPrice;
}
const parsePrice$4 = (priceFeature) => {
    if (priceFeature != null) {
        const price = parseFloat(priceFeature.values[0].key);
        const finalPrice = getLoanPrice$1(price);
        return isPriceInRange$1(finalPrice) ? finalPrice : null;
    }
    else {
        return null;
    }
};
function buildAgosAction$1(landingUrl, isMobile, agosPriceValue, rate) {
    const identifier = isMobile ? 'msite' : 'web';
    const replaceMED = '%med%';
    const urlSuffix = isMobile
        ? 'ddebd98d-ff1c-4b89-a242-03d51844fb78?'
        : 'a417c711-2bc9-4cca-b9e1-d96770c01f0b?';
    return landingUrl.includes(replaceMED)
        ? landingUrl.replace(replaceMED, identifier)
        : `https://agos.commander1.com/c3/?tcs=2498&chn=partners&src=subito.it&cmp=motori&pub=&med=${identifier}&fmt=widget&brk=R2&adgrp=&aff_id=&aff_name=&url=https://finanziamenti.agos.it/form/start/${urlSuffix}broker=R2&am=${agosPriceValue}&nr=${rate}&utm_medium=cpl&utm_source=display&utm_campaign=motori_sub&utm_content=widget`;
}
function getAgosPulseId$1(agosPriceValue) {
    let agos_pulse_id = 'agos';
    if (!!agosPriceValue && agosPriceValue <= 1000) {
        agos_pulse_id = 'agos-under1000';
    }
    else if (!!agosPriceValue &&
        agosPriceValue > 1000 &&
        agosPriceValue < 30000) {
        agos_pulse_id = 'agos-1001to29999';
    }
    else if (!!agosPriceValue && agosPriceValue >= 30000) {
        agos_pulse_id = 'agos-over30000';
    }
    return agos_pulse_id;
}
function getAgosUrl$1(landingUrl, agosPriceValue, rate, price, isMobile) {
    const url = buildAgosAction$1(landingUrl, isMobile, agosPriceValue, rate);
    if (!!price && price <= 1000) {
        if (isMobile) {
            return `https://track.adform.net/C/?bn=65600573`;
        }
        else {
            return `https://track.adform.net/C/?bn=63478822`;
        }
    }
    else if (!!price && price >= 30000) {
        if (isMobile) {
            return `https://track.adform.net/C/?bn=65600574`;
        }
        else {
            return `https://track.adform.net/C/?bn=63478823`;
        }
    }
    return url;
}
function LoanBoxComponent$3(props) {
    const [price, setPrice] = useState(parsePrice$4(props.price));
    const [rate, setRate] = useState('24');
    const { landingUrl = '', houstonTrackAncillary } = props;
    const { isMobile } = useViewport();
    const [dsaOpened, setDsaOpened] = useState(false);
    const onCloseDsa = () => {
        setDsaOpened(false);
    };
    const onOpenDsa = () => {
        setDsaOpened(true);
    };
    const pulseLabel = isMobile
        ? 'inside page'
        : 'rightside page';
    function onAgosSubmit(e) {
        e.preventDefault();
        const agosPriceValue = isPriceInRange$1(price) ? price : 0;
        const url = getAgosUrl$1(landingUrl, agosPriceValue, rate, price, isMobile);
        const agos_pulse_id = getAgosPulseId$1(agosPriceValue);
        trackWidgetClick(e, { pulse_id: agos_pulse_id, props }, pulseLabel);
        if (houstonTrackAncillary)
            houstonTrackAncillary('click_widget_agos');
        window.open(url);
        return false;
    }
    // We must only track the view once per mount.
    const [viewTracked, setViewTracked] = useState(false);
    useEffect(() => {
        if (viewTracked || !props.price) {
            return;
        }
        const price = parseFloat(props.price.values[0].key);
        let agos_pulse_id = 'agos';
        if (price <= 1000) {
            agos_pulse_id = 'agos-under1000';
        }
        else if (price > 1000 && price < 30000) {
            agos_pulse_id = 'agos-1001to29999';
        }
        else if (price >= 30000) {
            agos_pulse_id = 'agos-over30000';
        }
        trackWidgetView(agos_pulse_id, props, pulseLabel);
        houstonTrackAncillary?.('view_widget_agos');
        setViewTracked(true);
    }, [props, houstonTrackAncillary, pulseLabel, viewTracked]);
    return (React.createElement("div", { id: 'box_container', className: classnames['box_container'] },
        React.createElement("div", { className: classnames['header-container'] },
            React.createElement("div", null,
                React.createElement("img", { alt: "", className: `${classnames['box_logo']} ${classnames['box_logo_agos']}`, src: 'data:image/png;base64,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' })),
            React.createElement("div", { className: classnames['ad_info'] },
                React.createElement("p", null, "Pubblicit\u00E0"),
                React.createElement(Button, { design: "text", size: "small", icon: React.createElement(Icon, { name: IconName.Info, iconSize: IconSize.MD }), classes: [classnames['info-icon']], onClick: onOpenDsa }))),
        React.createElement("p", { className: classnames['box_payoff'] },
            "Richiedi il tuo prestito personale con ",
            React.createElement("strong", null, "Agos")),
        React.createElement("form", { name: "agos_form", id: "agos_form", method: "get", onSubmit: onAgosSubmit },
            React.createElement("div", { className: classnames['box_form_input'] },
                React.createElement("label", { htmlFor: "agos_price" }, "Importo"),
                React.createElement("input", { type: "number", name: "IMPOR", id: "agos_price", min: 0, value: price || '', onChange: (e) => setPrice(parseInt(e.target.value, 10)) })),
            React.createElement("div", { className: classnames['box_form_input'] },
                React.createElement("label", { htmlFor: "agos_rate" }, "Num. Rate"),
                React.createElement("select", { name: "nr", id: "agos_rate", onChange: (e) => setRate(e.target.value) },
                    React.createElement("option", { value: "24" }, "24"),
                    React.createElement("option", { value: "60" }, "60"),
                    React.createElement("option", { value: "96" }, "96"),
                    React.createElement("option", { value: "120" }, "120"))),
            React.createElement("button", { className: classnames['agos_background'], type: "submit", name: "agos_button", id: "agos_button" }, "Calcola subito")),
        React.createElement(DsaModal, { advertiser: "AGOS-DUCATO S.P.A.", agency: "TIG MEDIA S.R.L.", opened: dsaOpened, onClose: onCloseDsa })));
}
function LoanBox$4(props) {
    return (React.createElement(ErrorBoundary, null,
        React.createElement(LoanBoxComponent$3, { ...props })));
}

async function getUrl(price, loan, rate, useQueryParam = true // Optional parameter with default set to true
) {
    const urlEndpoint = 'https://www.credit-agricole.it/calcolo-rata/calculator';
    const data = {
        loan_quotation: {
            loan_amount: loan,
            property_value: price,
            requested_duration: rate,
            purpose: 'acquisto',
        },
    };
    try {
        let response;
        if (useQueryParam) {
            // Create the query string with the required structure
            const queryParams = new URLSearchParams();
            queryParams.append('loan_quotation[loan_amount]', loan.toString());
            queryParams.append('loan_quotation[property_value]', price.toString());
            queryParams.append('loan_quotation[requested_duration]', rate.toString());
            queryParams.append('loan_quotation[purpose]', 'acquisto');
            response = await fetch(`${urlEndpoint}?${queryParams.toString()}`, {
                method: 'POST', // Keep using POST method even with query params
                headers: {
                    'Content-Type': 'application/json',
                    Referer: 'https://www.subito.it',
                },
            });
        }
        else {
            // Send parameters via request body (POST)
            response = await fetch(urlEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Referer: 'https://www.subito.it',
                },
                body: JSON.stringify(data),
            });
        }
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const responseData = await response.json();
        return responseData.redirect_path;
    }
    catch (error) {
        console.error(error);
    }
}
function getCreditAgricoleEndpoint(loan, itemPrice, rate) {
    return getUrl(itemPrice, loan, rate);
}

function isLoanInRange$1(price, loan) {
    if (loan <= price * 0.8) {
        if (loan <= 1600000) {
            return loan;
        }
        else if (loan > 1600000) {
            return 1600000;
        }
    }
    return 0;
}
const parsePrice$3 = (priceFeature) => {
    if (priceFeature != null) {
        const price = parseFloat(priceFeature.values[0].key);
        return price;
    }
    else {
        return 0;
    }
};
function LoanBoxComponent$2(props) {
    const [price, setPrice] = useState();
    const [rate, setRate] = useState(10);
    const { assetsBase } = props;
    const itemPrice = parsePrice$3(props.price);
    const [dsaOpened, setDsaOpened] = useState(false);
    const onCloseDsa = () => {
        setDsaOpened(false);
    };
    const onOpenDsa = () => {
        setDsaOpened(true);
    };
    function onBoxSubmit(e, price, loan) {
        e.preventDefault();
        const fixedLoan = isLoanInRange$1(itemPrice, loan);
        if (fixedLoan) {
            getCreditAgricoleEndpoint(fixedLoan, itemPrice, rate).then((url) => {
                trackWidgetClick(e, { pulse_id: 'creditagricole-alwayson', props }, 'rightside page');
                window.open(`${url}&utm_source=subito&utm_medium=widget`);
            });
        }
    }
    // We must only track the view once per mount.
    const [viewTracked, setViewTracked] = useState(false);
    useEffect(() => {
        if (!viewTracked) {
            trackWidgetView('creditagricole-alwayson', props, 'rightside page');
            setViewTracked(true);
        }
    }, [props, viewTracked]);
    return (React.createElement("div", { className: classnames['box_container'] },
        React.createElement("div", { className: classnames['header-container'] },
            React.createElement("img", { alt: "", className: `${classnames['box_logo']} ${classnames['box_logo_credit_agricole']}`, src: `${assetsBase}/static/ancillary-services/credit-agricole/logo-credit-agricole.png` }),
            React.createElement("div", { className: classnames['ad_info'] },
                React.createElement(Button, { design: "text", size: "small", icon: React.createElement(Icon, { name: IconName.Info, iconSize: IconSize.MD }), classes: [classnames['info-icon']], onClick: onOpenDsa }))),
        React.createElement("p", { className: classnames['box_payoff'] }, "Calcola la rata del mutuo per l'acquisto di questo immobile"),
        React.createElement("form", { name: "credit_agricole_form", id: "credit_agricole_form", method: "get", onSubmit: (e) => onBoxSubmit(e, Number(itemPrice), Number(price)) },
            React.createElement("div", { className: classnames['box_form_input'] },
                React.createElement("label", { htmlFor: "credit_agricole_price" }, "Importo"),
                React.createElement("input", { type: "number", name: "IMPOR", id: "credit_agricole_price", min: 40000, max: Math.floor(Number(itemPrice)) * 0.8, value: price || '', onChange: (e) => setPrice(parseInt(e.target.value, 10)) })),
            React.createElement("div", { className: classnames['box_form_input'] },
                React.createElement("label", { htmlFor: "credit_agricole_rate" }, "Durata"),
                React.createElement("select", { name: "nr", id: "credit_agricole_rate", onChange: (e) => setRate(parseInt(e.target.value)) },
                    React.createElement("option", { value: 10 }, "10 anni"),
                    React.createElement("option", { value: 15 }, "15 anni"),
                    React.createElement("option", { value: 20 }, "20 anni"),
                    React.createElement("option", { value: 25 }, "25 anni"),
                    React.createElement("option", { value: 30 }, "30 anni"))),
            React.createElement("button", { className: classnames['credit_agricole_background'], type: "submit", name: "credit_agricole_button", id: "credit_agricole_button" }, "Calcola subito"),
            React.createElement("p", { className: classnames['box_form_notes'] }, "Messaggio promozionale. Informazioni Generali sul Credito Immobiliare in filiale e www.mutui.credit-agricole.it. Concessione del mutuo ipotecario soggetta ad approvazione della Banca.")),
        React.createElement(DsaModal, { advertiser: "Cr\u00E9dit Agricole Italia S.p.A", agency: "HEARTS & SCIENCE S.R.L.", opened: dsaOpened, onClose: onCloseDsa })));
}
function LoanBox$3(props) {
    return (React.createElement(ErrorBoundary, null,
        React.createElement(LoanBoxComponent$2, { ...props })));
}

function isPriceInRange(price) {
    return price && price >= 500;
}
function getLoanPrice(price) {
    if (price >= 30000) {
        return 30000;
    }
    const prefixPrice = Math.floor(price / 1000) * 1000;
    const leftOver = Math.floor(price % 1000);
    if (leftOver === 0) {
        return price;
    }
    const suffixPrice = leftOver < 400 ? 500 : 1000;
    return prefixPrice + suffixPrice;
}
const parsePrice$2 = (priceFeature) => {
    if (priceFeature != null) {
        const price = parseFloat(priceFeature.values[0].key);
        const finalPrice = getLoanPrice(price);
        return isPriceInRange(finalPrice) ? finalPrice : null;
    }
    else {
        return null;
    }
};
function buildAgosAction(landingUrl, isMobile, agosPriceValue, rate) {
    const identifier = isMobile ? 'msite' : 'web';
    const utm_content = isMobile ? 'widget-msite-new' : 'web_new';
    const replaceMED = '%med%';
    return landingUrl.includes(replaceMED)
        ? landingUrl.replace(replaceMED, identifier)
        : `https://agos.commander1.com/c3/?tcs=2498&chn=partners&src=subito.it&cmp=motori&pub=&med=${identifier}&fmt=widget&brk=R2&adgrp=&aff_id=&aff_name=&url=https://finanziamenti.agos.it/form/start/aacf91fe-19cd-4883-86d3-abb091873f32?broker=R2&am=${agosPriceValue}&nr=${rate}%&utm_medium=cpl&utm_source=display&utm_campaign=motori_sub&utm_content=${utm_content}`;
}
function getAgosPulseId(agosPriceValue) {
    let agos_pulse_id = 'agos';
    if (!!agosPriceValue && agosPriceValue <= 1000) {
        agos_pulse_id = 'agos-under1000';
    }
    else if (!!agosPriceValue &&
        agosPriceValue > 1000 &&
        agosPriceValue < 30000) {
        agos_pulse_id = 'agos-1001to29999';
    }
    else if (!!agosPriceValue && agosPriceValue >= 30000) {
        agos_pulse_id = 'agos-over30000';
    }
    return agos_pulse_id;
}
function getAgosUrl(landingUrl, agosPriceValue, rate, price, isMobile) {
    const url = buildAgosAction(landingUrl, isMobile, agosPriceValue, rate);
    if (!!price && price <= 1000) {
        if (isMobile) {
            return `https://track.adform.net/C/?bn=68271183`;
        }
        else {
            return `https://track.adform.net/C/?bn=68271189`;
        }
    }
    else if (!!price && price >= 30000) {
        if (isMobile) {
            return `https://track.adform.net/C/?bn=68271184`;
        }
        else {
            return `https://track.adform.net/C/?bn=68271190`;
        }
    }
    return url;
}
function LoanBoxComponent$1(props) {
    const [price, setPrice] = useState(parsePrice$2(props.price));
    const [rate, setRate] = useState('24');
    const { landingUrl = '', houstonTrackAncillary } = props;
    const { isMobile } = useViewport();
    const [dsaOpened, setDsaOpened] = useState(false);
    function onCloseDsa() {
        setDsaOpened(false);
    }
    function onOpenDsa() {
        setDsaOpened(true);
    }
    function onAgosSubmit(e) {
        e.preventDefault();
        const agosPriceValue = isPriceInRange(price) ? price : 0;
        const url = getAgosUrl(landingUrl, agosPriceValue, rate, price, isMobile);
        const agos_pulse_id = getAgosPulseId(agosPriceValue);
        trackWidgetClick(e, { pulse_id: agos_pulse_id, props }, 'inside page');
        if (houstonTrackAncillary)
            houstonTrackAncillary('click_widget_agos');
        window.open(url);
        return false;
    }
    // We must only track the view once per mount.
    const [viewTracked, setViewTracked] = useState(false);
    useEffect(() => {
        if (viewTracked || !props.price) {
            return;
        }
        const price = parseFloat(props.price.values[0].key);
        let agos_pulse_id = 'agos';
        if (price <= 1000) {
            agos_pulse_id = 'agos-under1000';
        }
        else if (price > 1000 && price < 30000) {
            agos_pulse_id = 'agos-1001to29999';
        }
        else if (price >= 30000) {
            agos_pulse_id = 'agos-over30000';
        }
        trackWidgetView(agos_pulse_id, props, 'inside page');
        houstonTrackAncillary?.('view_widget_agos');
        setViewTracked(true);
    }, [props, houstonTrackAncillary, viewTracked]);
    return (React.createElement("div", { id: 'box_container', className: classnames['block_container'] },
        React.createElement("div", { className: classnames['header-container'] },
            React.createElement("h2", { className: classnames$4('headline-6', classnames['item-title']) }, "Finanziamento"),
            React.createElement("div", null,
                React.createElement("img", { alt: "", className: `${classnames['box_logo']} ${classnames['box_logo_agos']}`, src: 'data:image/png;base64,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' }))),
        React.createElement("p", { className: classnames['block_payoff'] }, "Richiedi il tuo prestito personale con Agos."),
        React.createElement("form", { name: "agos_form", id: "agos_form", method: "get", onSubmit: onAgosSubmit, className: classnames['form_block'] },
            React.createElement("div", null,
                React.createElement("div", { className: classnames['box_form_input'] },
                    React.createElement("label", { htmlFor: "agos_price" }, "Importo"),
                    React.createElement("input", { type: "number", name: "IMPOR", id: "agos_price", min: 0, value: price ?? '', onChange: (e) => setPrice(parseInt(e.target.value, 10)) })),
                React.createElement("div", { className: classnames['box_form_input'] },
                    React.createElement("label", { htmlFor: "agos_rate" }, "Num. Rate"),
                    React.createElement("select", { name: "nr", id: "agos_rate", onChange: (e) => setRate(e.target.value) },
                        React.createElement("option", { value: "24" }, "24"),
                        React.createElement("option", { value: "60" }, "60"),
                        React.createElement("option", { value: "96" }, "96"),
                        React.createElement("option", { value: "120" }, "120")))),
            React.createElement(Button, { classes: [classnames['button']], design: "outline", name: "agos_button", type: "submit" }, "Calcola preventivo"),
            React.createElement("div", { className: classnames['ad_info'] },
                React.createElement("div", { className: classnames['ending-text'] }, "sponsorizzato"),
                React.createElement(Button, { design: "text", size: "small", icon: React.createElement(Icon, { name: IconName.Info, iconSize: IconSize.MD }), classes: [classnames['info-icon']], onClick: onOpenDsa }))),
        React.createElement(DsaModal, { advertiser: "AGOS-DUCATO S.P.A.", agency: "TIG MEDIA S.R.L.", opened: dsaOpened, onClose: onCloseDsa })));
}
function LoanBox$2(props) {
    return (React.createElement(ErrorBoundary, null,
        React.createElement(LoanBoxComponent$1, { ...props })));
}

function isLoanInRange(price, loan) {
    if (loan <= price * 0.8) {
        if (loan <= 1600000) {
            return loan;
        }
        else if (loan > 1600000) {
            return 1600000;
        }
    }
    return 0;
}
const parsePrice$1 = (priceFeature) => {
    if (priceFeature != null) {
        return parseFloat(priceFeature.values[0].key);
    }
    else {
        return 0;
    }
};
function LoanBoxComponent(props) {
    const [price, setPrice] = useState();
    const [rate, setRate] = useState(10);
    const { assetsBase } = props;
    const itemPrice = parsePrice$1(props.price);
    const [dsaOpened, setDsaOpened] = useState(false);
    const onCloseDsa = () => {
        setDsaOpened(false);
    };
    const onOpenDsa = () => {
        setDsaOpened(true);
    };
    function onBoxSubmit(e, loan) {
        e.preventDefault();
        const fixedLoan = isLoanInRange(itemPrice, loan);
        if (fixedLoan) {
            getCreditAgricoleEndpoint(fixedLoan, itemPrice, rate).then((url) => {
                trackWidgetClick(e, { pulse_id: 'creditagricole-alwayson', props }, 'inside page');
                window.open(`${url}&utm_source=subito&utm_medium=widget`);
            });
        }
    }
    // We must only track the view once per mount.
    const [viewTracked, setViewTracked] = useState(false);
    useEffect(() => {
        if (!viewTracked) {
            trackWidgetView('creditagricole-alwayson', props, 'inside page');
            setViewTracked(true);
        }
    }, [props, viewTracked]);
    return (React.createElement("div", { className: classnames['block_container'] },
        React.createElement("div", { className: classnames['header-container'] },
            React.createElement("h2", { className: classnames$4('headline-6', classnames['item-title']) }, "Finanziamento"),
            React.createElement("div", null,
                React.createElement("img", { alt: "", className: `${classnames['box_logo']} ${classnames['box_logo_credit_agricole']}`, src: `${assetsBase}/static/ancillary-services/credit-agricole/logo-credit-agricole.png` }))),
        React.createElement("p", { className: classnames['block_payoff'] }, "Calcola la rata del mutuo per l'acquisto di questo immobile"),
        React.createElement("form", { name: "credit_agricole_form", id: "credit_agricole_form", method: "get", onSubmit: (e) => onBoxSubmit(e, Number(price)), className: classnames['form_block'] },
            React.createElement("div", null,
                React.createElement("div", { className: classnames['box_form_input'] },
                    React.createElement("label", { htmlFor: "credit_agricole_price" }, "Importo"),
                    React.createElement("input", { type: "number", name: "IMPOR", id: "credit_agricole_price", min: 40000, max: Math.floor(Number(itemPrice)) * 0.8, value: price || '', onChange: (e) => setPrice(parseInt(e.target.value, 10)) })),
                React.createElement("div", { className: classnames['box_form_input'] },
                    React.createElement("label", { htmlFor: "credit_agricole_rate" }, "Durata"),
                    React.createElement("select", { name: "nr", id: "credit_agricole_rate", onChange: (e) => setRate(parseInt(e.target.value)) },
                        React.createElement("option", { value: 10 }, "10 anni"),
                        React.createElement("option", { value: 15 }, "15 anni"),
                        React.createElement("option", { value: 20 }, "20 anni"),
                        React.createElement("option", { value: 25 }, "25 anni"),
                        React.createElement("option", { value: 30 }, "30 anni")))),
            React.createElement(Button, { classes: [classnames['button-credit-agricole']], design: "outline", name: "credit_agricole_button", type: "submit" }, "Calcola subito"),
            React.createElement("div", { className: classnames['ad_info'] },
                React.createElement("p", { className: classnames['box_form_notes'] }, "Messaggio promozionale. Informazioni Generali sul Credito Immobiliare in filiale e www.mutui.credit-agricole.it. Concessione del mutuo ipotecario soggetta ad approvazione della Banca."),
                React.createElement(Button, { design: "text", size: "small", icon: React.createElement(Icon, { name: IconName.Info, iconSize: IconSize.MD }), classes: [classnames['info-icon']], onClick: onOpenDsa }))),
        React.createElement(DsaModal, { advertiser: "Cr\u00E9dit Agricole Italia S.p.A", agency: "HEARTS & SCIENCE S.R.L.", opened: dsaOpened, onClose: onCloseDsa })));
}
function LoanBox$1(props) {
    return (React.createElement(ErrorBoundary, null,
        React.createElement(LoanBoxComponent, { ...props })));
}

const parsePrice = (priceFeature) => {
    let adPrice = 0;
    if (priceFeature != null) {
        adPrice = Number.parseFloat(priceFeature.values[0].key);
    }
    if (adPrice < 2000) {
        return 2000;
    }
    else if (adPrice <= 30000) {
        // The price must be a multiple of 250
        const remainderOverChunk = adPrice % 250;
        return adPrice - remainderOverChunk;
    }
    else {
        return 30000;
    }
};
function PrestiPayBoxComponent(props) {
    const { assetsBase, price: adPrice = null } = props;
    const [dsaOpened, setDsaOpened] = useState(false);
    const [price, setPrice] = useState(parsePrice(adPrice));
    const priceRef = React.useRef(null);
    // We must only track the view once per mount.
    const [viewTracked, setViewTracked] = useState(false);
    useEffect(() => {
        if (!viewTracked) {
            trackWidgetView('prestypay-alwayson', props, 'rightside page');
            setViewTracked(true);
        }
    }, [props, viewTracked]);
    useEffect(() => {
        const priceInput = priceRef.current;
        if (priceInput == null) {
            return;
        }
        if (priceInput.validity.stepMismatch) {
            priceInput?.setCustomValidity('Il valore deve essere un multiplo di 250€');
            priceInput?.reportValidity();
        }
        else {
            priceInput?.setCustomValidity('');
        }
    }, [price]);
    return (React.createElement("aside", { className: classnames['box_container'] },
        React.createElement("header", { className: classnames['header-container'] },
            React.createElement("div", null,
                React.createElement("img", { src: `${assetsBase}/static/ancillary-services/loan-box/prestipay-logo.svg`, alt: "Prestipay", height: 32, className: `${classnames['box_logo']} ${classnames['box_logo_prestipay']}` })),
            React.createElement("div", { className: classnames['ad_info'] },
                React.createElement("small", { className: classnames['smallprint'] }, "Pubblicit\u00E0"),
                React.createElement(Button, { design: "text", size: "small", icon: React.createElement(Icon, { name: IconName.Info, iconSize: IconSize.MD }), classes: [classnames['info-icon']], onClick: () => {
                        setDsaOpened(true);
                    } }))),
        React.createElement("p", { className: classnames['box_payoff'] },
            "Richiedi il tuo prestito personale con ",
            React.createElement("b", null, "PrestiPay")),
        React.createElement("form", { name: "prestipay_loan_form", id: "prestipay_form", method: "GET", action: "https://www.prestipay.it/Preventivatore.html", onSubmit: (e) => {
                trackWidgetClick(e, { pulse_id: 'prestypay-alwayson', props }, 'rightside page');
            } },
            React.createElement("div", { className: classnames['box_form_input'] },
                React.createElement("label", { htmlFor: "prestipay_price" }, "Importo"),
                React.createElement("input", { type: "number", name: "importoRata", id: "prestipay_price", ref: priceRef, min: 2000, max: 30000, step: 250, required: true, value: Number.isNaN(price) ? 0 : price, onChange: (e) => {
                        setPrice(Number.parseInt(e.target.value, 10));
                    } })),
            React.createElement("div", { className: classnames['box_form_input'] },
                React.createElement("label", { htmlFor: "prestipay_rate" }, "Num. Rate"),
                React.createElement("select", { name: "durata", id: "prestipay_rate", required: true, defaultValue: "84" },
                    React.createElement("option", { value: "12" }, "12"),
                    React.createElement("option", { value: "24" }, "24"),
                    React.createElement("option", { value: "36" }, "36"),
                    React.createElement("option", { value: "48" }, "48"),
                    React.createElement("option", { value: "60" }, "60"),
                    React.createElement("option", { value: "72" }, "72"),
                    React.createElement("option", { value: "84" }, "84"))),
            React.createElement("input", { type: "hidden", name: "codiceBroker", value: "BR-010" }),
            React.createElement("input", { type: "hidden", name: "utm_source", value: "subito" }),
            React.createElement("input", { type: "hidden", name: "utm_medium", value: "widget" }),
            React.createElement("input", { type: "hidden", name: "utm_id", value: "br-010" }),
            React.createElement("button", { className: classnames['prestipay_background'], type: "submit" }, "Calcola subito")),
        React.createElement(DsaModal, { opened: dsaOpened, advertiser: "PRESTIPAY S.P.A.", agency: "PRESTIPAY S.P.A.", onClose: () => {
                setDsaOpened(false);
            } })));
}
function LoanBox(props) {
    return (React.createElement(ErrorBoundary, null,
        React.createElement(PrestiPayBoxComponent, { ...props })));
}

export { AdBannerService, LoanBox$2 as AgosBlock, LoanBox$4 as AgosBox, CardBlock, LoanBox$1 as CreditAgricoleBlock, LoanBox$3 as CreditAgricoleBox, DsaModal, MockDataCarWash, MockDataCardBlock, MockDataCreditAgricole, MockDataFindomestic, MockDataMacingoAnimali, MockDataMacingoAuto, MockDataMacingoMoto, MockDataMacingoNautica, MockDataTestDrive, MockDataVehicleHistory, MockDataVolksvagen, MockDataWesual, LoanBox as PrestiPayBox, TextLink, UsefulLinks as Usefullinks, initialCardBlockData };
//# sourceMappingURL=index.js.map
